import type { Agreement } from '@hero/schema';
import { isSameOrgId } from '../Route/utils';

/**
 * Returns the party in this agreement that ISN'T the current org (i.e. the
 * counterparty we contracted with). Falls back to `agreement.org` when the
 * `parties[]` tuple hasn't been populated yet (legacy docs).
 */
export function getAgreementCounterparty(
  agreement: Pick<Agreement, 'parties' | 'org'>,
  orgId?: string | undefined,
) {
  if (agreement.parties && agreement.parties.length === 2) {
    const [a, b] = agreement.parties;
    if (!orgId) return b;
    if (isSameOrgId(a._id, orgId)) return b;
    if (isSameOrgId(b._id, orgId)) return a;
    return b;
  }
  // Legacy / fallback: the agreement only has one denormalized org.
  return agreement.org;
}
